<template>
  <label class="form-inline-group">
    <input
      v-model="value"
      :title="title"
      :type="type"
      v-bind="attrs"
      true-value="yes"
      false-value="no"
      class="form-input"
      :class="`form-${type}`"
    />
    <span v-if="type === 'radio'" class="form-toggle" />
    <span v-else :for="attrs.name" class="form-checkbox">
      <span class="form-checkbox-no" :class="{ active: value !== 'yes' }"
        >No</span
      >
      <span class="form-checkbox-yes" :class="{ active: value === 'yes' }"
        >Yes</span
      >
      <span class="form-checkbox-active" />
    </span>
  </label>
</template>

<script lang="ts" setup>
const props = defineProps({
  index: { type: Number, default: 0 },
  type: String as () => 'checkbox' | 'radio',
  title: String,
  options: Array,
  modelValue: [String, Number, Boolean, Array],
  attrs: Object,
})
const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<style lang="scss">
.form {
  &-checkbox {
    $size: 1rem;
    position: relative;

    display: flex;
    flex-flow: row nowrap;

    background: var(--field-bg);
    border-radius: var(--br-items-sm) ;
    cursor: pointer;

    &-no,
    &-yes {
      position: relative;
      z-index: 10;

      display: inline-block;
      padding: czn.$rg + czn.$xs czn.$md + czn.$rg;

      color: var(--field-accent);

      transition: opacity 0.3s, font-weight 0.3s, background 0.3s;

      &.active {
        color: var(--field-inv);
        font-weight: bold;
      }
    }
    &-no {
      margin-right: 4px;
      border-radius: 0 var(--br-items-sm) var(--br-items-sm) 0;
    }
    &-active {
      position: absolute;

      width: 50%;
      padding: czn.$rg czn.$md;

      border: 2px solid var(--body);
      border-radius: var(--br-items-sm);
      background: var(--green);

      transition: transform 0.3s, background 0.3s;
      inset: 0;
    }
    &-group {
      flex-flow: column;
    }
  }
}
</style>
